import { cn } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';
import Popover from '../Popovers/Popover/Popover';

/**
 * @param {import('./lib/propTypes').InputOptionsProps} props
 */

const InputOptions = ({
  options = [],
  currentOption = null,
  onClickOption,
  position = 'bottom',
  className,
  panelClassName,
  disabled
}) => {
  const trigger = ({ open }) => {
    return (
      <div
        className={cn(
          'flex h-full min-w-[64px] shrink-0 select-none items-center justify-between gap-1 border-0 border-l border-solid border-neutral-200 bg-neutral-50 px-3 py-2',
          disabled && 'cursor-not-allowed opacity-60'
        )}>
        <p className="whitespace-nowrap text-sm font-400 not-italic leading-6 text-neutral-900">
          {currentOption}
        </p>
        <Icon
          icon="chevron-down-linear"
          color="neutral-500"
          size={20}
          className={cn('transition-transform duration-200', open && 'rotate-180')}
        />
      </div>
    );
  };

  return (
    <Popover
      isFixed
      isDropdown
      icon={false}
      position={position}
      disabled={disabled}
      text={currentOption}
      optionActiveIcon={null}
      options={options.map((option) => ({
        ...option,
        className: 'text-center h-[30px]'
      }))}
      onOptionClick={(option) => onClickOption(option?.value)}
      dataQa="popover-open"
      className={cn(
        'flex items-center !rounded-[4px] bg-neutral-100  hover:bg-neutral-200',
        className
      )}
      textClassName="text-neutral-600"
      panelClassName={cn('min-w-[75px]', panelClassName)}
      customButtonClassName="h-full !rounded-none"
      customButtonTrigger={trigger}
    />
  );
};

export default InputOptions;
